import { basicValidation } from '../basicValidation';
import { CommentReference } from '../../../DTOs/Comments';
import { CommentReferenceTypes } from '../../../DTOs';

export const commentValidation = {
    reference:(value:CommentReference)=> {

        if(typeof value !== 'object' || value === null)
            return false;

        if(!basicValidation.validateString(value.type, false, false, 1, 100))
            return false;

        if(!basicValidation.resourceId.isValid(value.id))
            return false;

        const type = value.type;
        if(!CommentReferenceTypes.includes(type as any))
            return false;

        return true;
    },
    streamId:(value:string)=> basicValidation.resourceId.isValid(value),
    id:(value:string)=> basicValidation.resourceId.isValid(value),
    content:(value:string)=> basicValidation.validateString(value, false, false, 1, 5000)
};